import { ErrorTypes } from '~domain/error/error-types';
import { isErrorTypeOf, isNotFoundClientError, isUnauthorizedClientError } from '~domain/helper/errors';

export function errorToMessageId(error: Error) {
  if (isErrorTypeOf(error, ErrorTypes.INVALID_CREDENTIALS_ERROR)) {
    return 'error.invalidCredentials';
  }

  if (isNotFoundClientError(error)) {
    return 'error.clientNotFound';
  }

  if (isUnauthorizedClientError(error)) {
    return 'error.clientUnauthorized';
  }

  if (isErrorTypeOf(error, ErrorTypes.CLIENT_REQUEST_ERROR)) {
    return 'error.clientRequestInvalid';
  }

  if (isErrorTypeOf(error, ErrorTypes.CLIENT_NETWORK_ERROR)) {
    return 'error.serverUnreachable';
  }

  if (isErrorTypeOf(error, ErrorTypes.CLIENT_SERVER_ERROR)) {
    return 'error.serverError';
  }

  if (isErrorTypeOf(error, ErrorTypes.CLIENT_TIMEOUT_ERROR)) {
    return 'error.serverTimeout';
  }

  return 'error.unknownError';
}
